
        var result = require("!!../../node_modules/_css-loader@1.0.1@css-loader/index.js!../../node_modules/_resolve-url-loader@3.1.0@resolve-url-loader/index.js!../../node_modules/_sass-loader@7.1.0@sass-loader/lib/loader.js??ref--4-3!./global.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    